'use client';

import Popup from '@/components/elements/Popup';
import { usePopup } from '@/features/stores/popup-store';
import useLoginDrawer from '@/hooks/useLoginDrawerStore';

function NeedLoginDialog() {
  const { open, close } = usePopup();
  const { openDrawer } = useLoginDrawer();

  const openDrawerHandle = () => {
    close();
    openDrawer('login');
  };

  return (
    <Popup isOpen={open} onClose={close} title="Sign in to upgrade">
      <div className="mb-6">
        <p>
          You need an account to purchase a subscription. Sign in or create one and we’ll take you
          straight to checkout.
        </p>
      </div>
      <div className="flex justify-end gap-2">
        <button className="rounded-md border px-4 py-2 text-sm" onClick={close}>
          Cancel
        </button>
        <button
          className="bg-primary text-text rounded-md px-4 py-2 text-sm"
          onClick={openDrawerHandle}
        >
          Sign in
        </button>
      </div>
    </Popup>
  );
}
export default NeedLoginDialog;
